(function($) {

	var $body = $('body');
	var $windowWidth = $(window).width();

	toggleNavigation = function() {
		$('.navigation--trigger').on('click', function(e){
			e.preventDefault();
			if($('body').hasClass('navigation--open')) {
				$('body').removeClass('navigation--open');
			}
			else {
				$('body').addClass('navigation--open');
			}
		}); 
	};

	/*----------  Open and close subnavigation on touch devices  ----------*/
	toggleSubNav = function() {
		$(".submenu-trigger + a, .submenu-trigger").on('click', function(e){
			e.stopPropagation();
			e.preventDefault();
			$('.sub-menu a').unbind('click');

			if($windowWidth > 1139){
				if($(this).parent('.menu-item').hasClass('open-subnav')) {
					$('.menu-item').removeClass('open-subnav');
					$body.removeClass('subnav--open');
				}
				else {
					$('.menu-item').removeClass('open-subnav');
					$(this).parent('.menu-item').addClass('open-subnav');
					$body.addClass('subnav--open');
				}
			}
			else {
				if($(this).parent('.menu-item').hasClass('open-subnav')) {
					$(this).parent('.menu-item').removeClass('open-subnav');
				}
				else {
					$(this).parent('.menu-item').addClass('open-subnav');
				}
			}
		}); 

		$('body, .close--navigation').on('click', function(e){
			if( $windowWidth > 1149 && $('.submenu-trigger').parent('.menu-item').hasClass('open-subnav') ){
				$('.menu-item').removeClass('open-subnav');
				$body.removeClass('subnav--open');
			}
		}); 

		$('.menu-item-73 a').unbind('click');
	}


	toggleSearch = function() {
		$('.search--trigger').on('click', function(e){
			e.stopPropagation();
			e.preventDefault();
			if($(this).hasClass('icon-search')) {
				$(this).removeClass('icon-search');
				$(this).addClass('icon-times');
				$('#form-search').addClass('show');
			}
			else {
				$(this).addClass('icon-search');
				$(this).removeClass('icon-times');
				$('#form-search').removeClass('show');
			}
		}); 
	};

	scrollMenu = function() {

		var didScroll;
		var lastScrollTop = 0;
		var delta = 5;
		var navbarHeight = $('.header').outerHeight();

		$(window).scroll(function(event){
			didScroll = true;
		});

		setInterval(function() {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);

		function hasScrolled() {
			var st = $(this).scrollTop();

			if(Math.abs(lastScrollTop - st) <= delta)
				return;
			
			if (st > lastScrollTop && st > navbarHeight){
				$('.header').fadeOut();
			} else {
				if(st + $(window).height() < $(document).height()) {
					$('.header').fadeIn();
				}
			}
			
			lastScrollTop = st;
		}
	}


})(jQuery); // Fully reference jQuery after this point.
